import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-bootstrap';

import { DisplayIdModule } from '../../../directives';
import { CustomInterceptor } from './../../../helper';
import { SharedModule } from '../../shared';

// Routing
import { CustomerRoutingModule } from './customer-routing.module';

import { CustomerAddComponent, CustomerAddService } from './customer-add';
import { CustomerEditComponent, CustomerEditService } from './customer-edit';
import {
  CustomerDetailComponent,
  CustomerDetailService,
  CustomerUpdateStatusService,
  CustomerSiteSummaryService,
  CustomerResetPasswordService
} from './customer-detail';
import { CustomerSummaryComponent, CustomerSummaryService } from './customer-summary';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DisplayIdModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
    
    CustomerRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    CustomerAddComponent,
    CustomerEditComponent,
    CustomerDetailComponent,
    CustomerSummaryComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    CustomerAddService,
    CustomerEditService,
    CustomerSummaryService,
    CustomerDetailService,
    CustomerUpdateStatusService,
    CustomerSiteSummaryService,
    CustomerResetPasswordService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ],
})
export class CustomerModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer.module.ts